import {
  ActionBar,
  ChakraBox,
  ChakraText,
  FAIconName,
  FireflyButton,
} from '@equip.health/ui';
import { SUPPORT_EMAIL } from '~/lib/constants/global.constants';

const ErrorMessagesFallback = ({
  resetErrorBoundary,
}: {
  resetErrorBoundary: (...args: Array<unknown>) => void;
}) => {
  return (
    <>
      <ActionBar
        id="error-messages-fallback"
        text={
          <ChakraBox textAlign="center" width="100%">
            <ChakraText
              fontSize="15px"
              fontWeight={400}
              letterSpacing="-0.03em"
              lineHeight="1.25"
            >
              {`Error loading messages, please reach out to `}
              <ChakraText
                as="a"
                href={`mailto:${SUPPORT_EMAIL}`}
                textDecoration="underline"
              >
                {SUPPORT_EMAIL}
              </ChakraText>
              {` if the problem persists`}
            </ChakraText>
          </ChakraBox>
        }
        textPlacement="center"
        variant="critical"
      />

      <ChakraBox margin="15px">
        <FireflyButton
          id="error-messages-reload-button"
          leftIcon={FAIconName.refreshRegular}
          onClick={resetErrorBoundary}
          variant="secondary"
        >
          Reload
        </FireflyButton>
      </ChakraBox>
    </>
  );
};

export default ErrorMessagesFallback;
